import React from "react";
import { makeStyles, Box, Typography } from "@material-ui/core";
import ReactPlayer from "react-player";
import { getLang } from "app/feature/constants";

const useStyle = makeStyles(theme => ({
  root: {
    margin: theme.spacing(0, 2),
    borderRadius: 10,
    overflow: "hidden",
    minWidth: "fit-content",
    "& iframe": {
      border: "none",
      overflow: "hidden"
    },
    maxHeight: 640,
    backgroundColor: "black",
  },
  placeholder: {
    width: "100%",
    height: 200,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    padding: 2,
    backgroundColor: theme.palette.background.paper
  }
}));

export default function WebVideoComponent({ lang, url, enableAutoplay }) {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      {!url ? (
        <Box className={classes.placeholder}>
          <Typography
            variant="body2"
            color="primary"
            style={{ 
              fontWeight: "bold",
              textAlign: "center"
            }}
          >
            {getLang(lang, "label.WEB_VIDEO_PLAYER")}
          </Typography>
          <Typography
            variant="body2"
            color="primary"
            style={{ 
              textAlign: "center"
            }}
          >
            {getLang(lang, "paragraph.WEB_VIEW_NO_VIDEO")}
          </Typography>
        </Box>
      ) : (
        <ReactPlayer
          url={url}
          playing={enableAutoplay}
          controls
          width="100%"
          loop={true}
          volume={1}
          muted={true}
        />
      )}
    </div>
  );
}